// SMS Service for sending payment reminders
// This uses Twilio as an example, but you can replace with any SMS service

// Configuration - Replace with your actual SMS service credentials
const SMS_CONFIG = {
  // For Twilio
  accountSid: process.env.REACT_APP_TWILIO_ACCOUNT_SID || 'your_twilio_account_sid',
  authToken: process.env.REACT_APP_TWILIO_AUTH_TOKEN || 'your_twilio_auth_token',
  fromNumber: process.env.REACT_APP_TWILIO_FROM_NUMBER || '+1234567890',
  
  // For other services, add their specific config
  // apiKey: process.env.REACT_APP_SMS_API_KEY,
  // apiUrl: process.env.REACT_APP_SMS_API_URL,
};

// Send SMS using Twilio
export const sendSMSTwilio = async (toNumber, message) => {
  try {
    // Note: Twilio client-side SDK is not recommended for security
    // This should be done server-side. For now, we'll simulate it
    
    console.log('=== SMS SENT (Twilio Simulation) ===');
    console.log('To:', toNumber);
    console.log('From:', SMS_CONFIG.fromNumber);
    console.log('Message:', message);
    console.log('====================================');
    
    // TODO: Replace with actual Twilio API call
    // const response = await fetch('/api/send-sms', {
    //   method: 'POST',
    //   headers: { 'Content-Type': 'application/json' },
    //   body: JSON.stringify({ to: toNumber, message })
    // });
    
    return {
      success: true,
      messageId: 'simulated_sms_id',
      message: 'SMS sent successfully (simulated)'
    };
  } catch (error) {
    console.error('SMS sending failed:', error);
    return {
      success: false,
      error: error.message,
      message: 'Failed to send SMS'
    };
  }
};

// Send SMS using generic HTTP API (for services like MSG91, TextLocal, etc.)
export const sendSMSGeneric = async (toNumber, message, serviceConfig = {}) => {
  try {
    const config = {
      apiKey: serviceConfig.apiKey || SMS_CONFIG.apiKey,
      apiUrl: serviceConfig.apiUrl || SMS_CONFIG.apiUrl,
      senderId: serviceConfig.senderId || 'GYMFAC',
      ...serviceConfig
    };
    
    console.log('=== SMS SENT (Generic API Simulation) ===');
    console.log('To:', toNumber);
    console.log('Message:', message);
    console.log('Service Config:', config);
    console.log('==========================================');
    
    // TODO: Replace with actual API call
    // const response = await fetch(config.apiUrl, {
    //   method: 'POST',
    //   headers: { 
    //     'Content-Type': 'application/json',
    //     'Authorization': `Bearer ${config.apiKey}`
    //   },
    //   body: JSON.stringify({
    //     to: toNumber,
    //     message: message,
    //     sender: config.senderId
    //   })
    // });
    
    return {
      success: true,
      messageId: 'simulated_sms_id',
      message: 'SMS sent successfully (simulated)'
    };
  } catch (error) {
    console.error('SMS sending failed:', error);
    return {
      success: false,
      error: error.message,
      message: 'Failed to send SMS'
    };
  }
};

// Main SMS sending function
export const sendSMS = async (toNumber, message, service = 'twilio') => {
  // Validate phone number
  if (!toNumber || !message) {
    return {
      success: false,
      message: 'Phone number and message are required'
    };
  }
  
  // Clean phone number (remove spaces, dashes, etc.)
  const cleanNumber = toNumber.replace(/[\s\-()]/g, '');
  
  // Add country code if not present (assuming India +91)
  const formattedNumber = cleanNumber.startsWith('+91') ? cleanNumber : 
                         cleanNumber.startsWith('91') ? `+${cleanNumber}` :
                         cleanNumber.startsWith('0') ? `+91${cleanNumber.slice(1)}` :
                         `+91${cleanNumber}`;
  
  try {
    switch (service.toLowerCase()) {
      case 'twilio':
        return await sendSMSTwilio(formattedNumber, message);
      case 'generic':
      case 'msg91':
      case 'textlocal':
        return await sendSMSGeneric(formattedNumber, message);
      default:
        return await sendSMSTwilio(formattedNumber, message);
    }
  } catch (error) {
    return {
      success: false,
      error: error.message,
      message: 'SMS service not available'
    };
  }
};

// Send payment reminder SMS
export const sendPaymentReminderSMS = async (member, reminderType = 'due') => {
  try {
    if (!member.phone) {
      return {
        success: false,
        message: 'Member phone number not available'
      };
    }
    
    const dueDate = new Date(member.nextDueDate);
    const daysUntilDue = Math.ceil((dueDate - new Date()) / (1000 * 60 * 60 * 24));
    
    // Create SMS message (shorter than email)
    let smsMessage = '';
    
    switch (reminderType) {
      case 'reminder':
        smsMessage = `Dear ${member.fullName}, your gym payment of ₹${member.fees} is due on ${dueDate.toLocaleDateString()} (in ${daysUntilDue} days). Please pay to avoid membership interruption. - DE MUSCLE FACTORY`;
        break;
      case 'overdue':
        smsMessage = `URGENT: Dear ${member.fullName}, your gym payment of ₹${member.fees} is overdue by ${Math.abs(daysUntilDue)} days. Please pay immediately to avoid suspension. - DE MUSCLE FACTORY`;
        break;
      case 'upcoming':
        smsMessage = `Dear ${member.fullName}, your gym payment of ₹${member.fees} will be due on ${dueDate.toLocaleDateString()}. Please plan accordingly. - DE MUSCLE FACTORY`;
        break;
      default:
        smsMessage = `Dear ${member.fullName}, your gym payment of ₹${member.fees} is due on ${dueDate.toLocaleDateString()}. Please ensure timely payment. - DE MUSCLE FACTORY`;
    }
    
    // Send SMS
    const result = await sendSMS(member.phone, smsMessage);
    
    return {
      ...result,
      memberName: member.fullName,
      memberPhone: member.phone,
      reminderType,
      smsMessage
    };
    
  } catch (error) {
    return {
      success: false,
      error: error.message,
      message: 'Failed to send payment reminder SMS'
    };
  }
}; 